"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPROACHING_ANALYSIS_BUILD_STATUSES = exports.ANALYZABLE_BUILD_STATUSES = exports.POST_REVIEW_ERROR_ORIGIN_STATUSES = exports.PRE_REVIEW_BUILD_STATUSES = exports.TIMED_OUT_PREDECESSORS_BY_REASON = exports.BUILD_STATUS_TRANSITIONS = exports.TransitionOutcome = void 0;
exports.isPreReviewBuildStatus = isPreReviewBuildStatus;
exports.canBeginBomMerge = canBeginBomMerge;
exports.canTransition = canTransition;
exports.legalPredecessorsOf = legalPredecessorsOf;
exports.isTerminalBuildStatus = isTerminalBuildStatus;
exports.isAnalyzableBuildStatus = isAnalyzableBuildStatus;
exports.isBoundForAnalysis = isBoundForAnalysis;
const build_automation_1 = require("./build-automation");
const build_status_1 = require("./build-status");
var TransitionOutcome;
(function (TransitionOutcome) {
    TransitionOutcome["Transitioned"] = "transitioned";
    TransitionOutcome["AlreadyInTarget"] = "already_in_target";
    TransitionOutcome["Refused"] = "refused";
})(TransitionOutcome || (exports.TransitionOutcome = TransitionOutcome = {}));
exports.BUILD_STATUS_TRANSITIONS = {
    [build_status_1.BuildStatus.Pending]: [build_status_1.BuildStatus.Validating, build_status_1.BuildStatus.Error, build_status_1.BuildStatus.Abandoned],
    [build_status_1.BuildStatus.Validating]: [build_status_1.BuildStatus.Processing, build_status_1.BuildStatus.Error, build_status_1.BuildStatus.Abandoned],
    [build_status_1.BuildStatus.Processing]: [
        build_status_1.BuildStatus.BomAwaitingReview,
        build_status_1.BuildStatus.Error,
        build_status_1.BuildStatus.TimedOut,
        build_status_1.BuildStatus.Abandoned,
    ],
    [build_status_1.BuildStatus.Error]: [
        build_status_1.BuildStatus.Processing,
        build_status_1.BuildStatus.BomAwaitingReview,
        build_status_1.BuildStatus.ProcessingBom,
        build_status_1.BuildStatus.ReadyToAnalyze,
        build_status_1.BuildStatus.Abandoned,
    ],
    [build_status_1.BuildStatus.BomAwaitingReview]: [build_status_1.BuildStatus.ProcessingBom, build_status_1.BuildStatus.TimedOut, build_status_1.BuildStatus.Abandoned],
    [build_status_1.BuildStatus.ProcessingBom]: [
        build_status_1.BuildStatus.ReadyToAnalyze,
        build_status_1.BuildStatus.Error,
        build_status_1.BuildStatus.TimedOut,
        build_status_1.BuildStatus.Abandoned,
    ],
    [build_status_1.BuildStatus.ReadyToAnalyze]: [
        build_status_1.BuildStatus.ProcessingDesign,
        build_status_1.BuildStatus.TimedOut,
        build_status_1.BuildStatus.CreditRequired,
        build_status_1.BuildStatus.Abandoned,
    ],
    [build_status_1.BuildStatus.ProcessingDesign]: [
        build_status_1.BuildStatus.AnalysisComplete,
        build_status_1.BuildStatus.Complete,
        build_status_1.BuildStatus.Error,
        build_status_1.BuildStatus.Abandoned,
    ],
    [build_status_1.BuildStatus.AnalysisComplete]: [build_status_1.BuildStatus.Complete, build_status_1.BuildStatus.ProcessingDesign, build_status_1.BuildStatus.Abandoned],
    [build_status_1.BuildStatus.Complete]: [build_status_1.BuildStatus.ProcessingDesign, build_status_1.BuildStatus.Abandoned],
    [build_status_1.BuildStatus.TimedOut]: [build_status_1.BuildStatus.Processing, build_status_1.BuildStatus.Abandoned],
    [build_status_1.BuildStatus.CreditRequired]: [build_status_1.BuildStatus.ProcessingDesign, build_status_1.BuildStatus.Abandoned],
    [build_status_1.BuildStatus.Abandoned]: [],
    [build_status_1.BuildStatus.Unknown]: [],
};
exports.TIMED_OUT_PREDECESSORS_BY_REASON = {
    [build_status_1.BuildTimeoutReason.ParseWait]: [build_status_1.BuildStatus.Processing],
    [build_status_1.BuildTimeoutReason.NetlistWait]: [
        build_status_1.BuildStatus.Processing,
        build_status_1.BuildStatus.BomAwaitingReview,
        build_status_1.BuildStatus.ProcessingBom,
        build_status_1.BuildStatus.ReadyToAnalyze,
    ],
};
exports.PRE_REVIEW_BUILD_STATUSES = [
    build_status_1.BuildStatus.Pending,
    build_status_1.BuildStatus.Validating,
    build_status_1.BuildStatus.Processing,
];
function isPreReviewBuildStatus(status) {
    return exports.PRE_REVIEW_BUILD_STATUSES.includes(status);
}
exports.POST_REVIEW_ERROR_ORIGIN_STATUSES = Object.values(build_status_1.BuildStatus).filter((status) => !isPreReviewBuildStatus(status) && status !== build_status_1.BuildStatus.Error && status !== build_status_1.BuildStatus.Unknown);
function canBeginBomMerge(status, erroredFromStatus) {
    if (!canTransition(status, build_status_1.BuildStatus.ProcessingBom)) {
        return false;
    }
    return (status !== build_status_1.BuildStatus.Error ||
        (erroredFromStatus !== undefined && exports.POST_REVIEW_ERROR_ORIGIN_STATUSES.includes(erroredFromStatus)));
}
function canTransition(from, to) {
    return exports.BUILD_STATUS_TRANSITIONS[from].includes(to);
}
function legalPredecessorsOf(target) {
    return Object.keys(exports.BUILD_STATUS_TRANSITIONS).filter((from) => canTransition(from, target));
}
function isTerminalBuildStatus(status) {
    return exports.BUILD_STATUS_TRANSITIONS[status].length === 0;
}
exports.ANALYZABLE_BUILD_STATUSES = new Set(legalPredecessorsOf(build_status_1.BuildStatus.ProcessingDesign));
function isAnalyzableBuildStatus(status) {
    return exports.ANALYZABLE_BUILD_STATUSES.has(status);
}
exports.APPROACHING_ANALYSIS_BUILD_STATUSES = new Set([
    build_status_1.BuildStatus.Validating,
    build_status_1.BuildStatus.Processing,
    build_status_1.BuildStatus.BomAwaitingReview,
    build_status_1.BuildStatus.ProcessingBom,
]);
function isBoundForAnalysis(status, automationMode) {
    if (exports.APPROACHING_ANALYSIS_BUILD_STATUSES.has(status)) {
        return true;
    }
    return (status === build_status_1.BuildStatus.ReadyToAnalyze &&
        (0, build_automation_1.isAutomationStepEnabled)(automationMode, build_automation_1.BuildAutomationStep.DispatchAnalysis));
}
//# sourceMappingURL=build-status-transitions.js.map